import {
	getProductCardSuccess,
	editorChoiceItemSuccess as editorChoiceProductCardSuccess,
	requestStart as productCardRequestStart,
	requestFailure as productCardRequestFailure,
} from '../product/productcard';
import * as i18n from 'i18next';
import { IStore } from 'redux/IStore';
import { IEditorChoiceItem } from 'models/common';
import { actions as notifActions } from 'redux-notifications';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { EditorChoiceNodeType } from 'models/enums/nodetype/editorchoicenodetype';

const { notifSend } = notifActions;

export class EditorChoices {
	private editorChoiceNodeType: EditorChoiceNodeType;
	private nodeType: NodeType;
	private editorChoiceItemSuccess: () => void;
	private requestStart: () => void;
	private requestFailure: (message: any) => void;
	private updateItemsSuccess: (items: any) => void;

	constructor(editorChoiceNodeType: EditorChoiceNodeType) {
		this.editorChoiceNodeType = editorChoiceNodeType;

		switch (this.editorChoiceNodeType) {
			case EditorChoiceNodeType.ProductCard:
				this.editorChoiceItemSuccess = editorChoiceProductCardSuccess;
				this.requestStart = productCardRequestStart;
				this.requestFailure = productCardRequestFailure;
				this.updateItemsSuccess = getProductCardSuccess;
				this.nodeType = NodeType.Product;
				break;
			default:
		}
	}

	public updateEditorChoiceItems(editorChoiceItems?: any) {
		return (dispatch, getState: () => IStore) => {
			// update array of items
			if (this.isArrayNode()) {
				this.updateArrayOfItems(editorChoiceItems, getState(), dispatch);
				// update object
			} else {
				this.updateObject(editorChoiceItems, getState(), dispatch);
			}
		};
	}

	public editorChoice(itemId: string, entityId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType) {
				type = nodeType;
			}
			dispatch(this.updateEditorChoiceItem(itemId, undefined));

			const itemToGet = JSON.stringify({ entityId });

			return fetch(
				getState().fetchDefault.baseAPI + 'api/MenuItem/SetEditorChoice' + '/' + itemId,
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'PUT',
					body: itemToGet,
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.editorChoiceItemSuccess());
						dispatch(this.updateEditorChoiceItem(itemId, true));
						if (type === NodeType.Product) {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_EditorChoice_Product'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						} else {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_EditorChoice_WardrobeItem'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						}
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public editorChoiceRemove(itemId: string, entityId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType) {
				type = nodeType;
			}
			dispatch(this.updateEditorChoiceItem(itemId, undefined));

			const itemToGet = JSON.stringify({ entityId });

			return fetch(
				getState().fetchDefault.baseAPI + 'api/MenuItem/RemoveEditorChoice' + '/' + itemId,
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'PUT',
					body: itemToGet,
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.editorChoiceItemSuccess());
						dispatch(this.updateEditorChoiceItem(itemId, false));
						if (type === NodeType.Product) {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_EditorChoiceRemoved_Product'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						} else {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_EditorChoiceRemoved_WardrobeItem'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						}
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	private updateEditorChoiceItem(itemId: string, isAdded: boolean | undefined) {
		return (dispatch, getState: () => IStore) => {
			const data = this.getNodeItems(getState());
			if (!data) {
				return;
			}

			// update array of items
			if (this.isArrayNode()) {
				const itemInList: any = data.filter((x) => x.id === itemId)[0];
				const itemIndex = data.indexOf(itemInList);
				if (itemIndex > -1) {
					data[itemIndex].editorChoice = isAdded;
					dispatch(this.updateItemsSuccess(data));
				}
				// update object
			} else {
				data.editorChoice = isAdded;
				dispatch(this.updateItemsSuccess(data));
			}
		};
	}

	private updateArrayOfItems(editorChoiceItems: IEditorChoiceItem[], state: IStore, dispatch: any) {
		const data: any[] = this.getNodeItems(state);
		if (editorChoiceItems !== null) {
			editorChoiceItems.forEach((editorChoiceItem: IEditorChoiceItem) => {
				const item: any = data.filter((i) => i.id === JSON.parse(editorChoiceItem.key.entityId).id)[0];
				if (!item) {
					return;
				}
				const itemIndex = data.indexOf(item);
				item.editorChoice = editorChoiceItem.value;
				data[itemIndex] = item;
			});
		} else {
			data.map((item) => {
				item.editorChoice = false;
			});
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private updateObject(editorChoiceItem: IEditorChoiceItem, state: IStore, dispatch: any) {
		const data: any = this.getNodeItems(state);
		if (!data) {
			return;
		}
		if (editorChoiceItem !== null) {
			if (data.id === JSON.parse(editorChoiceItem.key.entityId).id) {
				data.editorChoice = editorChoiceItem.value;
			}
		} else {
			data.editorChoice = false;
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private isArrayNode(): boolean {
		if (
			this.editorChoiceNodeType === EditorChoiceNodeType.ProductSearch ||
			this.editorChoiceNodeType === EditorChoiceNodeType.Product ||
			this.editorChoiceNodeType === EditorChoiceNodeType.ProductsYouMayAlsoLike ||
			this.editorChoiceNodeType === EditorChoiceNodeType.WardrobeItemSearch
		) {
			return true;
		} else {
			return false;
		}
	}

	private getNodeItems(state: IStore) {
		let data = null;
		if (this.editorChoiceNodeType === EditorChoiceNodeType.Product) {
			data = state.products.items;
		} else if (this.editorChoiceNodeType === EditorChoiceNodeType.ProductCard) {
			data = state.productCard.productCard;
		} else if (this.editorChoiceNodeType === EditorChoiceNodeType.ProductSearch) {
			data = state.productSearchResults.items;
		} else if (this.editorChoiceNodeType === EditorChoiceNodeType.ProductsYouMayAlsoLike) {
			data = state.youMayAlsoLikeProducts.items;
		} else if (this.editorChoiceNodeType === EditorChoiceNodeType.WardrobeItemSearch) {
			data = state.wardrobeItemSearchResults.items;
		}
		return data;
	}
}
